module.exports = __webpack_public_path__ + "img/Frame11.9d40e4f4.png";